/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneVideoBaseContent as ResolvedStandaloneVideoBaseContent } from 'base/components/standalone/VideoBaseContent';

export const VideoBaseContent: typeof ResolvedStandaloneVideoBaseContent = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneVideoBaseContent {...props} />
        </ErrorBoundary>
    );
});

export type VideoBaseContentProps = PropsFromComponent<typeof VideoBaseContent>;

/** @deprecated Use slot architecture instead */
export const VideoBaseContentWith = (extras: DynamicStandaloneExtras): typeof VideoBaseContent => {
    return function VideoBaseContent(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'VideoBaseContent');
        return <ResolvedStandaloneVideoBaseContent {...mergeProps({ options: { theme } }, props)} />;
    }
}